var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("polling-channel", {
    attrs: {
      input: _vm.places,
      active: _vm.pollingActive,
      updateFunction: _vm.pollPlaceUpdate,
      interval: 1000,
    },
    on: { valueUpdated: _vm.onPlacePollingUpdate },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (props) {
          return [
            _c(
              "div",
              [
                _c(
                  "page-title-area",
                  {
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "side-content",
                          fn: function () {
                            return [
                              _c("entity-search-field", {
                                attrs: { placeholder: _vm.$t("search") },
                                model: {
                                  value: _vm.searchText,
                                  callback: function ($$v) {
                                    _vm.searchText = $$v
                                  },
                                  expression: "searchText",
                                },
                              }),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "right-floating-content",
                          fn: function () {
                            return [_c("station-plan-status")]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      true
                    ),
                  },
                  [_c("h1", [_vm._v("S-TYPE")])]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "d-flex align-baseline justify-end mt-4" },
                  [
                    _vm.featureIsActive("s_type_scanner_upload")
                      ? [
                          _c(
                            "round-button",
                            {
                              attrs: { icon: "camera_alt" },
                              on: { click: _vm.openScannerUpload },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("scanner_upload.button")) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "ml-1" }),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _c("csv-import-button", {
                      on: { placesCreated: _vm.loadPlaces },
                    }),
                  ],
                  2
                ),
                _vm._v(" "),
                _c("station-place-table", {
                  attrs: {
                    places: props.currentValue,
                    loading: _vm.loading,
                    users: _vm.users,
                    "current-user-id": _vm.currentUserId,
                    query: _vm.query,
                  },
                  on: {
                    edit: _vm.editPlace,
                    delete: _vm.confirmDelete,
                    toggleHidden: _vm.toggleHidden,
                  },
                }),
                _vm._v(" "),
                _c("confirm-dialog", {
                  attrs: {
                    message: _vm.$t("confirm_delete", {
                      placeName: _vm.deleteTarget.name,
                    }),
                  },
                  on: {
                    yes: function ($event) {
                      return _vm.deletePlace(_vm.deleteTarget)
                    },
                  },
                  model: {
                    value: _vm.deleteConfirmDialogVisible,
                    callback: function ($$v) {
                      _vm.deleteConfirmDialogVisible = $$v
                    },
                    expression: "deleteConfirmDialogVisible",
                  },
                }),
                _vm._v(" "),
                _c("station-place-editor", {
                  attrs: { place: _vm.editTarget, users: _vm.users },
                  on: { update: _vm.updateTable },
                  model: {
                    value: _vm.editorVisible,
                    callback: function ($$v) {
                      _vm.editorVisible = $$v
                    },
                    expression: "editorVisible",
                  },
                }),
                _vm._v(" "),
                _c("scanner-upload-dialog", {
                  ref: "scannerUploadDialog",
                  attrs: { places: props.currentValue },
                  on: { uploaded: _vm.onScannerUpload },
                  model: {
                    value: _vm.scannerUploadDialogVisible,
                    callback: function ($$v) {
                      _vm.scannerUploadDialogVisible = $$v
                    },
                    expression: "scannerUploadDialogVisible",
                  },
                }),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }